import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('items');

export interface ItemDetailGetApiRequest {
  itemCode: string;
}

// 徐々に項目が追加される想定でDetailと命名
export interface ItemDetail {
  itemCode: string;
  displayName: string;
}

export interface ItemDetailApiResponse {
  item: ItemDetail;
  result: CommonResult;
}

export interface ItemDetailApiResponseErrorResponse {
  itemMaster: ItemDetail;
  result: CommonResult;
}

export async function itemDetailGetApi(request: ItemDetailGetApiRequest): Promise<ItemDetailApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.get<ItemDetailApiResponse>(`${URL}?itemCode=${request.itemCode}`, {
      headers,
    });
    const data = response.data;
    const status = response.status;

    if (status === OK.status) {
      return data;
    } else {
      throw response;
    }
  } catch (error) {
    return {
      item: {
        itemCode: '',
        displayName: '',
      },
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}`,
          },
        ],
      },
    };
  }
}
